import { Injectable } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class I18nService {
  private languageStorageKey = 'AppLanguage';
  private currentLanguageSubject = new BehaviorSubject<string>('en'); // Default language

  currentLanguage$ = this.currentLanguageSubject.asObservable(); // Expose as observable

  defaultLanguage: any;
  supportedLanguages: any[] = [];

  constructor(private translateService: TranslateService) {}

  init(defaultLanguage: any, supportedLanguages: any[]) {
    this.defaultLanguage = defaultLanguage;
    this.supportedLanguages = supportedLanguages;

    // Set the language explicitly during initialization
    const storedLanguage = this.appLanguage;
    const initialLanguage = storedLanguage
      ? storedLanguage.code
      : this.defaultLanguage.code;
    this.translateService.setDefaultLang(initialLanguage);
    this.translateService.use(initialLanguage);
    this.currentLanguageSubject.next(initialLanguage);

    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      const newLanguage =
        this.searchLanguage(event.lang) || this.defaultLanguage;
      this.setLanguage(newLanguage);
      this.currentLanguageSubject.next(newLanguage.code);
    });
  }

  set language(language: string) {
    let browserCulture = this.translateService.getBrowserCultureLang();
    browserCulture = browserCulture || 'en';

    language =
      this.searchLanguage(language)?.code ||
      this.appLanguage?.code ||
      this.searchLanguage(browserCulture)?.code;
    let isSupportedLanguage = this.supportedLanguages.some(
      (lang) => lang.code === language
    );

    // If no exact match is found, search without the region
    if (language && !isSupportedLanguage) {
      language = this.searchLanguage(language.split('-')[0]) || '';
      isSupportedLanguage = Boolean(language);
    }

    // Fallback if language is not supported
    language = isSupportedLanguage ? language : this.defaultLanguage.code;

    localStorage.setItem(
      this.languageStorageKey,
      JSON.stringify(this.searchLanguage(language) || this.defaultLanguage)
    );
    this.translateService.use(language);
    this.currentLanguageSubject.next(language);
  }

  get language(): string {
    return this.translateService.currentLang;
  }
  getLocalizedProperty(object: any, baseProperty: string): any {
    const currentLang = this.language;
    if (currentLang === 'en') return object[baseProperty];
    const localizedProperty = `${currentLang}${
      baseProperty.charAt(0).toUpperCase() + baseProperty.slice(1)
    }`;
    return object[localizedProperty] || object[baseProperty];
  }
  get appLanguage() {
    const storedValue = localStorage.getItem(this.languageStorageKey);
    if (storedValue !== null) return JSON.parse(storedValue);
    return this.defaultLanguage;
  }

  searchLanguage(language: string): any {
    return this.supportedLanguages.find((supportedLanguage) =>
      supportedLanguage.code.startsWith(language)
    );
  }

  setLanguage(language: { name: string; code: string }) {
    localStorage.setItem(this.languageStorageKey, JSON.stringify(language));
    this.translateService.use(language.code); // Apply the language change
    this.currentLanguageSubject.next(language.code); // Notify subscribers
  }
}

// import { Injectable } from '@angular/core';
// import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
// import { BehaviorSubject } from 'rxjs';

// /** constants */
// import { environment } from 'src/environments/environment';

// @Injectable({
//   providedIn: 'root',
// })
// export class I18nService {
//   private languageStorageKey = 'AppLanguage';
//   // private currentLanguageSubject = new BehaviorSubject<string>('en'); // Default language
//   // currentLanguage$ = this.currentLanguageSubject.asObservable();
//   defaultLanguage: any;
//   supportedLanguages: any[] = [];

//   constructor(private translateService: TranslateService) {}

//   init(defaultLanguage: any, supportedLanguages: any[]) {
//     this.defaultLanguage = defaultLanguage;
//     this.supportedLanguages = supportedLanguages;

//     // Set the language explicitly during initialization
//     const storedLanguage = this.appLanguage;
//     const initialLanguage = storedLanguage
//       ? storedLanguage.code
//       : this.defaultLanguage.code;
//     this.translateService.setDefaultLang(initialLanguage);
//     this.translateService.use(initialLanguage);

//     this.translateService.onLangChange.subscribe((event: LangChangeEvent) =>
//       this.setLanguage(this.searchLanguage(event.lang) || this.defaultLanguage)
//     );
//   }
//   getLocalizedProperty(object: any, baseProperty: string): any {
//     const currentLang = this.language; // Get the current language code (e.g., 'am' or 'or')
//     const localizedProperty = `${currentLang}${
//       baseProperty.charAt(0).toUpperCase() + baseProperty.slice(1)
//     }`;
//     return object[localizedProperty] || object[baseProperty];
//   }
//   set language(language: string) {
//     let browserCulture = this.translateService.getBrowserCultureLang();
//     browserCulture = browserCulture || 'en';

//     language =
//       this.searchLanguage(language)?.code ||
//       this.appLanguage?.code ||
//       this.searchLanguage(browserCulture)?.code;
//     let isSupportedLanguage =
//       (this.supportedLanguages.find(
//         (lang) => lang.code == language
//       ) as boolean) || false;

//     // If no exact match is found, search without the region
//     if (language && !isSupportedLanguage) {
//       language = this.searchLanguage(language.split('-')[0]) || '';
//       isSupportedLanguage = Boolean(language);
//     }

//     // Fallback if language is not supported
//     language = isSupportedLanguage ? language : this.defaultLanguage.code;

//     localStorage.setItem(
//       this.languageStorageKey,
//       JSON.stringify(this.searchLanguage(language) || this.defaultLanguage)
//     );
//     this.translateService.setDefaultLang(language);
//   }

//   get language(): string {
//     return this.translateService.currentLang;
//   }

//   get appLanguage() {
//     const storedValue = localStorage.getItem(this.languageStorageKey);

//     if (storedValue !== null) return JSON.parse(storedValue);

//     return environment.languageConfig.defaultLanguage;
//   }

//   searchLanguage(language: string): any {
//     return this.supportedLanguages.find((supportedLanguage) =>
//       supportedLanguage.code.startsWith(language)
//     );
//   }

//   setLanguage(language: { name: string; code: string }) {
//     localStorage.setItem(this.languageStorageKey, JSON.stringify(language));
//   }
// }
